export default "__VITE_ASSET__aND0WoiZ__"